import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const planosAcaoSlice = createSlice({
  name: 'planosAcao',
  initialState,
  reducers: {
    carregarPlanosAcao: (state, action) => {
      const { key, planosAcao } = action.payload;
      state[key] = planosAcao;
    },
    atualizarPlanosAcao: (state, action) => {
      const { key, planosAcao } = action.payload;
      state[key] = planosAcao;
    },
  },
});

export const { carregarPlanosAcao, atualizarPlanosAcao } = planosAcaoSlice.actions;

export default planosAcaoSlice.reducer;